<style lang="css">

</style>

<template lang="html">

<el-row>
      <el-row>
        <el-form :inline="true" :model="queryParam" class="demo-form-inline">
            <el-form-item>
                <withdraw-channel-select @change="onChannelChanged" placeholder="请选择渠道来源">
                </withdraw-channel-select>
            </el-form-item>
          <el-select v-model="queryParam.badFlag"   @change="search" clearable filterable placeholder="风险类型">
            <el-option label="待检查" value="1"></el-option>
            <el-option label="异常" value="2"></el-option>
            <el-option label="正常" value="3"></el-option>
            <el-option label="可信度低" value="4"></el-option>
            <el-option label="未找到" value="5"></el-option>
          </el-select>
            <el-form-item>
              <el-select v-model="queryParam.status" clearable @change="search" placeholder="请选择状态">
                <el-option label="待审核" :value="1"></el-option>
                <el-option label="审核通过" :value="2"></el-option>
                <el-option label="审核不通过" :value="3"></el-option>
                <el-option label="暂缓" :value="4"></el-option>
                <el-option label="异常提现" :value="5"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="queryParam.payStatus" clearable @change="search" placeholder="请选择提现状态">
                <el-option label="支付成功" :value="1"></el-option>
                <el-option label="支付失败" :value="2"></el-option>
                <el-option label="待处理" :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
                <el-date-picker
                  v-model="queryParam.activeTime"
                  clearable
                  @change="search"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="活跃开始日期"
                  end-placeholder="活跃结束日期">
                </el-date-picker>
            </el-form-item>

            <el-form-item>

                <el-date-picker
                  v-model="queryParam.createTime"
                  clearable
                  @change="search"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="申请开始日期"
                  end-placeholder="申请结束日期">
                </el-date-picker>
            </el-form-item>

            <el-form-item>
                <el-input v-model="queryParam.keyword" placeholder="请输入电话号码">
                </el-input>
            </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="search">搜索</el-button>
          </el-form-item>
        </el-form>
    </el-row>

    <el-table :data="tableData"   @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
        <el-table-column min-width="160px" label="申请时间">
            <template scope="scope">
                {{scope.row.createTime | dateTimeFormat}}
            </template>
        </el-table-column>

        <el-table-column min-width="160px" label="注册时间">
          <template scope="scope">
            <span>{{scope.row.lcwUserCreateTime | dateTimeFormat}}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="160px" label="最近活跃">
          <template scope="scope">
            <span>{{scope.row.loginTime | dateTimeFormat}}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="100px" label="ip">
          <template scope="scope">
            {{scope.row.ip}}
          </template>
        </el-table-column>
        <el-table-column min-width="200px" label="用户名称">
          <template scope="scope">
            <a @click="$router.push({name:'邀请列表',params:{id:scope.row.lcwUserInfoId,withdrawCashId:scope.row.id}})" style="color:red;">{{scope.row.nickname}}{{scope.row.personPhone}}</a>
          </template>
        </el-table-column>

        <el-table-column min-width="150px" label="风险 - 来源">
            <template scope="scope">
              <span>{{scope.row.badFlag}}</span>
              -
              <span style="color:#409EFF;">{{scope.row.channelName?scope.row.channelName:'暂无'}} </span>
            </template>
        </el-table-column>

        <el-table-column label="提现金额">
          <template scope="scope">
            {{scope.row.money}} 元
          </template>
        </el-table-column>
        <el-table-column min-width="140px" label="审核 - 提现 状态">
            <template scope="scope">
                <span v-bind:style="{color: getAuditStatusColor(scope.row.status)}">{{scope.row.status | coinWithdrawCashFilter}}</span>
                -
                <span v-bind:style="{color: getPayStatusColor(scope.row.status)}">{{scope.row.payStatus | coinWithdrawCashPayFilter}}</span>
            </template>
        </el-table-column>
        <el-table-column min-width="200px" label="操作">
            <template scope="scope">
             <div>
                <el-button  v-if="scope.row.status==1" @click="showAuditStatusDialog(scope.row.id,2)" size="mini" type="text">通过</el-button>
                <el-button  v-if="scope.row.status==1" @click="showAuditStatusDialog(scope.row.id,3)" size="mini" type="text">不通过</el-button>
               <el-button  v-if="scope.row.status==4" @click="disposeTemporary(scope.row.id)" size="mini" type="text">处理暂缓订单</el-button>
              </div>

              <div style="font-size:12px;" v-if="scope.row.auditTime">
                <p>{{scope.row.auditPersonName}} {{scope.row.auditTime | dateTimeFormat}}</p>
              </div>

            </template>
        </el-table-column>
    </el-table>
  <div style="margin-top: 20px" v-if="multipleSelection.length">
    <el-button type="info" @click="batchAuditing(2)">批量通过</el-button>
    <el-button type="danger"  @click="batchAuditing(3)">批量不通过</el-button>
  </div>
    <el-pagination style="margin-top:10px;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
</el-row>

</template>

<script>
import WithdrawChannelSelect from './children/WithdrawChannelSelect'
import coinModel from '@/framework/models/coinModel'
import BasicPager from '@/mixins/BasicPager'
export default {
  name: 'withdraw-cash',
  extends: BasicPager,
  data: function () {
    return {
      multipleSelection: [],
      queryParam: {},
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10
    }
  },
  components: {
    WithdrawChannelSelect
  },
  created: function () {
    this.loadList()
  },
  activated: function () {
    this.loadList()
  },
  methods: {
    disposeTemporary (id) {
      let that = this
      let params = {
        withdrawId: id
      }
      let listener = {
        success: function (dataInfo) {
          that.$message({
            message: '操作成功！',
            type: 'success'
          })
          that.loadList()
        }
      }

      coinModel.disposeTemporary(that, params, listener)
    },
    batchAuditing (status) {
      let that = this
      let withdrawIds = new Array()
      that.$confirm('请确认你的审核操作是否无误？', '提现审核后不能逆转，请二次确认！', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'info'
      }).then((confirm) => {
        if (confirm == 'confirm') {
          if (that.multipleSelection.length) {
            for (var i = 0; i < that.multipleSelection.length; i++) {
              if (that.multipleSelection[i].status != 1 && that.multipleSelection[i].status != status) {
                that.$message({
                  message: '您勾选的提现订单状态与修改状态不符合！',
                  type: 'info'
                })
                return
              }
              withdrawIds.push(that.multipleSelection[i].id)
            }

            let params = {
              withdrawIds: withdrawIds.join(),
              auditStatus: status,
              employeeId: that.loginInfo.employeeId,
              employeeName: that.loginInfo.realName
            }
            let listener = {
              success: function (dataInfo) {
                that.$message({
                  message: '操作成功！',
                  type: 'success'
                })
                that.loadList()
              }
            }

            coinModel.batchAuditing(that, params, listener)
          }
        }
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },

    onChannelChanged: function (channelId) {
      this.queryParam.channelId = channelId
      this.search()
    },
    search: function () {
      this.pageNum = 1
      this.loadList()
    },
    getAuditStatusColor: function (status) {
      let color = ''
      switch (status) {
        case 1:
          color = '#909399'
          break
        case 2:
          color = '#67C23A'
          break
        case 3:
          color = '#F56C6C'
          break
        case 4:
          color = '#909399'
          break
        default:
      }
      return color
    },
    getPayStatusColor: function (status) {
      let color = ''
      switch (status) {
        case 1:
          color = '#67C23A'
          break
        case 2:
          color = '#F56C6C'
          break
        case 3:
          color = '#909399'
          break
        default:
      }
      return color
    },
    handleSizeChange: function (pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    handleCurrentChange: function (pageNum) {
      this.pageNum = pageNum
      this.loadList()
    },
    showAuditStatusDialog: function (id, auditStatus) {
      this.$confirm('请确认你的审核操作是否无误？', '提现审核后不能逆转，请二次确认！', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.changeAuditStatus(id, auditStatus)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    changeAuditStatus: function (id, auditStatus) {
      let _this = this
      let params = {
        id: id,
        auditStatus: auditStatus,
        employeeId: this.loginInfo.employeeId,
        employeeName: this.loginInfo.realName
      }
      let listener = {
        success: function (dataInfo) {
          _this.$message({
            message: '操作成功！',
            type: 'success'
          })
          _this.loadList()
        }
      }
      coinModel.changeAuditStatus(_this, params, listener)
    },
    loadList: function () {
      let _this = this
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum

      }

      if (this.queryParam.channelId) {
        params.channelId = this.queryParam.channelId
      }

      if (this.queryParam.status) {
        params.status = this.queryParam.status
      }
      if (this.queryParam.badFlag) {
        params.badFlag = this.queryParam.badFlag
      }

      if (this.queryParam.payStatus) {
        params.payStatus = this.queryParam.payStatus
      }

      if (this.queryParam.createTime && this.queryParam.createTime[0]) {
        params.startTime = this.queryParam.createTime[0].getTime()
        params.endTime = this.queryParam.createTime[1].getTime()
      }

      if (this.queryParam.activeTime && this.queryParam.activeTime[0]) {
        params.activeStartTime = this.queryParam.activeTime[0].getTime()
        params.activeEndTime = this.queryParam.activeTime[1].getTime()
      }

      if (this.queryParam.keyword) {
        params.keyword = this.queryParam.keyword
      }

      let listener = {
        success: function (dataInfo) {
          _this.tableData = dataInfo.data
          _this.total = dataInfo.recordsTotal
        }
      }
      coinModel.findWithdrawMoneyRecord(_this, params, listener)
    }
  }
}

</script>
